import React from "react";
import { rotuloStatus } from "./propostaFormato";

// O texto sempre acompanha a cor (WCAG 1.4.1); a bolinha e so reforco visual.
export default function StatusBadge({ status }) {
  return (
    <span className={`status-badge status-badge--${status}`}>
      <span className="status-badge-dot" aria-hidden="true" />
      {rotuloStatus(status)}
    </span>
  );
}
